module.exports = __webpack_public_path__ + "img/icon-sta1.cd4e0bdb.png";